<template>
  <div class="row col-12 px-0 pt-4">
    <div class="titular col-9 ml-3">
      <h5 v-if="titulo1">{{ titulo1 }}</h5>
      <h4 class="text-azul-medio">{{ titulo2 }}</h4>
      <h6>
        <strong v-if="tipoEncabezado === 'FICHA_CARRERA'">Título:</strong>
        {{ titulo3 }}
      </h6>
      <br v-if="titulo4" />
      <h6 v-if="titulo4">
        <strong>Grado académico:</strong>
        {{ titulo4 }}
      </h6>
      <br v-if="demre" />
      <h6 v-if="demre">
        <strong>Código DEMRE:</strong>
        {{ demre }}
      </h6>
    </div>

    <div
      class="col-1 ml-auto px-0 d-flex align-items-end justify-content-end no-print"
    >
      <div class="#" @click="contactame">
        <h3 class="mb-3" v-b-tooltip.hover title="Contáctenme">
          <FontAwesomeIcon icon="envelope" class="ml-md-4" />
        </h3>
      </div>
      <div class="#" @click="volver">
        <h3 class="mb-3">
          <img
            src="@/assets/img/iconos/volver-1.svg"
            class="ml-3 ml-md-4"
            v-b-tooltip.hover
            title="Volver"
          />
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ModalContacto, ModalContactoTP } from "@/utils/BusesDeEventos.js";
library.add(faEnvelope, faPrint);
export default {
  name: "Titulo",
  props: {
    titulo1: { type: String, default: null },
    titulo2: { type: String },
    titulo3: { type: String },
    titulo4: { type: String },
    demre: { type: Number },
    volverA: { type: String },
    tipoEncabezado: { type: String },
    datosContacto: { type: Object }
  },
  components: {
    FontAwesomeIcon
  },
  methods: {
    volver() {
      this.$router.go(-1);
      //this.$router.push({ name: this.volverA });
    },
    contactame() {
      switch (this.tipoEncabezado) {
        case "FICHA_UNIVERSIDAD":
        case "FICHA_CARRERA":
          ModalContacto.$emit("contactame", this.datosContacto);
          break;
        case "FICHA_INSTITUTO":
        case "FICHA_CARRERA_TP":
          ModalContactoTP.$emit("contactameTP", this.datosContacto);
        default:
          break;
      }
    },
    descargarFicha() {
      this.$ga.event({
        eventCategory: "Sistema-Acceso",
        eventAction: "imprimir-ficha",
        eventLabel: "boton-imprimir"
      });
      this.$emit("descargar");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/generales/paginas/TituloFicha.vue